mutation PublishBimClassRevision (
    $id: ID!
    $revisionID: ID!
) {
    tagBimClass(
        id: $id
        revisionID: $revisionID
        tag: "public"
    )
}
